<template>
	<div  >
		<div class="edit-ask">
			<span class="ask-header">Circle</span>
			<div class="picker-icon picker-name" @click="showDialog = true">
				<font-awesome-icon class='small-icon' icon="pencil-alt" />
			</div>
			<md-dialog :md-active.sync="showDialog">
				<md-dialog-title>Select Circle</md-dialog-title>
				<md-field class='searcher'>
					<label>Current Circle: {{circleName}}</label>
				</md-field>
				<md-table>
					<md-table-row v-for="(circle, idx) in circles" :key="`${idx}-${circle.short}`">
						<md-table-cell>
							<label>
							<input type="radio" class="hide" name="selectedCircle" v-bind:value="circle.short" v-model="selectedCircle"  />
							<i class="selector fa fa-fw fa-check-circle"></i></label>
						</md-table-cell>
						<md-table-cell>{{circle.name}}</md-table-cell>
					</md-table-row>
				</md-table>
				<md-dialog-actions>
					<md-button class="md-primary" @click="cancel()">Cancel</md-button>
					<md-button class="md-primary" @click="updateCircle()" :disabled="selectedCircle == null">save</md-button>
				</md-dialog-actions>
			</md-dialog>
		</div>
			<span>{{circleName}}</span>
	</div>
</template>

<script>
import API from "../services/API";
export default {
	name: "CirclePicker",
	props: ['ask'],
	data: () => ({
		api: new API(),
		showDialog: false,
		selectedCircle: null,
		circleName: null,
		circles: []
	}),
	computed: {
		// The circle currently assigned to the request (its `short` code).
		currentShort() {
			return this.ask ? this.ask.sourceparam : null;
		}
	},
	watch: {
		ask: {
			handler() { this.loadData(); },
			immediate: true
		},
		// Pre-mark the current circle every time the picker is opened.
		showDialog(open) {
			if (open) this.selectedCircle = this.currentShort;
		}
	},
	methods: {
		loadData() {
			const community = this.ask && this.ask.community;
			if (!community) return;
			const communityId = typeof community === 'object' ? community._id : community;

			this.api.get(`communities/${communityId}/circles`).then(res => {
				// Available options always load, independent of whether the
				// request currently has a circle assigned.
				this.circles = res.data.filter(c => (c.name && c.name.trim().length > 1));
				// Resolve the current circle's display name (if any).
				const current = this.circles.find(c => c.short == this.currentShort);
				this.circleName = current ? current.name : null;
				this.selectedCircle = this.currentShort;
			});
		},
		cancel: function () {
			this.showDialog = false;
			this.selectedCircle = this.currentShort;
		},
		updateCircle() {
			this.api.post(`asks/${this.ask._id}/update-circle`, {circle: this.selectedCircle}).then(res => {
				const picked = this.circles.find(c => c.short == this.selectedCircle);
				if (picked) this.circleName = picked.name;
				this.ask.sourceparam = this.selectedCircle;
				this.showDialog = false;
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/CirclePicker.vue